import { Location } from '@angular/common';
import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CsvService } from '../../core';
import { QuestionsStatsService } from './services/questions-stats.service';

@Component({
  selector: 'lms-mars1-questions',
  templateUrl: './mars1-questions.component.html',
  styleUrls: ['./mars1-questions.component.scss'],
  providers: [QuestionsStatsService]
})
export class Mars1QuestionsComponent implements OnInit, OnChanges {
  @Input() listId: string;
  @Input() group: any;
  @Input() options: any;
  public stats: any = null;
  public listOptions: any;
  public groupQuestions: any[];

  constructor(
    public questionStats: QuestionsStatsService,
    public csvService: CsvService,
    public location: Location,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    this.groupQuestions = [];
    const groupId = this.group.id;
    this.questionStats.getGroupQuestionsStats({ groupId: groupId }).subscribe((stats) => {
      const totalAnswers = stats.groupRightAnswers + stats.groupWrongAnswers;
      this.stats = {
        ...stats,
        percentage: totalAnswers === 0 ? 0 : stats.groupRightAnswers / totalAnswers,
        ratioAnswers: stats.totalQuestionCreated === 0 ? 0 : totalAnswers / stats.totalQuestionCreated
      };
    });
  }

  ngOnChanges() {
    this.listOptions = Object.assign({}, this.options);
  }

  setCollection(collection) {
    this.groupQuestions = collection;
  }

  download() {
    const rows = this.groupQuestions.map((groupQuestion) => {
      const privateRows = [];
      privateRows['question'] = groupQuestion.question;
      privateRows['status'] = groupQuestion.status;
      privateRows['author'] = groupQuestion.createdByEmail || '--';
      privateRows['numLikes'] = groupQuestion.likes || 0;
      privateRows['numDislikes'] = groupQuestion.dislikes || 0;
      privateRows['numRightAnswers'] = groupQuestion.right || 0;
      privateRows['numWrongAnswers'] = groupQuestion.wrong || 0;
      privateRows['numWildcards'] = groupQuestion.wildcard || 0;
      privateRows['likesPrize'] = groupQuestion.likesPrize || 0;
      // Choice processing
      groupQuestion.choices.forEach((choice, idx) => {
        privateRows[`choice${idx + 1}Text`] = choice.text;
      });
      const correctChoiceIdx = groupQuestion.choices.findIndex((choice) => choice.isCorrect === true) || null;
      privateRows['correctChoice'] = correctChoiceIdx >= 0 ? `choice${correctChoiceIdx + 1}` : '--';

      privateRows['creationDate'] = new Date(groupQuestion.created_at);
      return privateRows;
    });

    this.csvService.dataToCsv(rows, this.group.name, {
      showLabels: true,
      headers: Object.keys(rows[0])
    });
  }

  goBack(): void {
    this.location.back();
  }
}
